export const initialValues = {
    text: '',
    image: null,
};
